export default "__VITE_ASSET__DDs2es5Z__"